import {Component, OnDestroy, OnInit} from '@angular/core';

import {FormControl, FormGroup} from "@angular/forms";
import {first} from "rxjs/operators";
import {MatDatepickerInputEvent} from "@angular/material/datepicker";
import {AlertService} from "../../services";
import {ComponentTitleService} from "../../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {CustomerMetricsService} from "../service/customerMetricsService";
import {WorkTimeService} from "../../workTime/service/workTime.service";
import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {WorkTimeSummaryList} from "../../workTime/model/workTimeSummaryList";
import {User} from "../../models";
import {WorkTimeDetailsDialogComponent} from "../../workTime/dialog/workTimeDetails.component";
import {MatDialog} from "@angular/material/dialog";
import {WorkTimeReportDialogComponent} from "./dialog/workTimeReportDialog.component";

@Component({
    templateUrl: './workTime.component.html',
    styleUrls: ['./workTime.component.scss']
})

export class WorkTimeReportComponent implements OnDestroy, OnInit {
    dateRange: FormGroup;
    fastDate: string = 'lastWeek';
    fromDate: string;
    toDate: string;
    workTimeSummaryList: WorkTimeSummaryList;
    countedWorkTime: Array<any> = [];
    dialogRef: any;

    constructor(
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private customerMetricsService: CustomerMetricsService,
        private workTimeService: WorkTimeService,
        public _matDialog: MatDialog,
    ) {
        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Reports');

        let today = new Date();

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });
    }

    ngOnInit() {
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-7)));
        let end = this.convertDateToString(new Date());

        this.updateReportData(start, end);
    }

    ngOnDestroy(): void {

    }

    updateReportData(createdAt: string, createdAtTo: string): void {
        this.fromDate = createdAt;
        this.toDate = createdAtTo;

        this.workTimeSummaryList = {items: []};
        this.countedWorkTime = [];
        this.workTimeService.getForWorkersByTimespan(this.fromDate, this.toDate).pipe(first()).subscribe((res: WorkTimeSummaryList) => {
            this.workTimeSummaryList = res;

            let total = this.workTimeSummaryList.items.length;
            let foundElement = false;

            for (let i = 0; i<total; i++) {
                // Skip entries with unrealistic work time (more than 24 hours = 86400 seconds)
                // This filters out entries without endWork or with incorrect data
                const MAX_WORK_TIME_SECONDS = 86400; // 24 hours
                if (!this.workTimeSummaryList.items[i].timeISeconds ||
                    this.workTimeSummaryList.items[i].timeISeconds > MAX_WORK_TIME_SECONDS) {
                    console.warn('Skipping invalid work time entry:', this.workTimeSummaryList.items[i]);
                    continue;
                }

                let key = this.workTimeSummaryList.items[i].userId;
                let visibleDate = this.workTimeSummaryList.items[i].day + "." + this.workTimeSummaryList.items[i].month + '.' + this.workTimeSummaryList.items[i].year;
                let j=0;
                for (j; j<this.countedWorkTime.length; j++) {
                    if (this.countedWorkTime[j].key === key) {
                        foundElement = true;
                        break;
                    }
                }

                if (!foundElement) {
                    this.countedWorkTime.push({
                        detailsDate: this.workTimeSummaryList.items[i].year + "-" + this.workTimeSummaryList.items[i].month + '-' + this.workTimeSummaryList.items[i].day,
                        date: visibleDate,
                        key: key,
                        timeInSeconds: 0,
                        timeInMinutes: 0,
                        timeInHours: 0,
                        timeInString: '0h 0m 0s',
                        userId: this.workTimeSummaryList.items[i].userId,
                        username: this.workTimeSummaryList.items[i].username,
                        firstName: this.workTimeSummaryList.items[i].firstName,
                        lastName: this.workTimeSummaryList.items[i].lastName,
                        total: 0,
                    });

                    j = this.countedWorkTime.length-1;
                }

                let seconds = this.countedWorkTime[j].timeInSeconds + this.workTimeSummaryList.items[i].timeISeconds;
                let hours = Math.floor(seconds/3600);
                let s = seconds%3600;
                let minutes = Math.floor(s/60);
                s = s%60;

                this.countedWorkTime[j] = {
                    detailsDate: this.workTimeSummaryList.items[i].year + "-" + this.workTimeSummaryList.items[i].month + '-' + this.workTimeSummaryList.items[i].day,
                    date: visibleDate,
                    key: key,
                    timeInSeconds: this.countedWorkTime[j].timeInSeconds + this.workTimeSummaryList.items[i].timeISeconds,
                    timeInMinutes: this.countedWorkTime[j].timeInMinutes + Math.round(this.workTimeSummaryList.items[i].timeISeconds*100/60)/100,
                    timeInHours: this.countedWorkTime[j].timeInHours + Math.round(this.workTimeSummaryList.items[i].timeISeconds*100/3600)/100,
                    timeInString: hours + 'h ' + minutes + 'm ' + s + 's',
                    userId: this.workTimeSummaryList.items[i].userId,
                    username: this.workTimeSummaryList.items[i].username,
                    firstName: this.workTimeSummaryList.items[i].firstName,
                    lastName: this.workTimeSummaryList.items[i].lastName,
                    total: this.countedWorkTime[j].timeInSeconds + this.workTimeSummaryList.items[i].timeISeconds,
                };

                let secondsT = this.countedWorkTime[j].total;
                let hoursT = Math.floor(secondsT/3600);
                let sT = secondsT%3600;
                let minutesT = Math.floor(sT/60);
                sT = sT%60;

                this.countedWorkTime[j].totalInString = hoursT + 'h ' + minutesT + 'm ' + sT + 's';

                foundElement = false;
            }
        });
    }

    convertDateToString(date: Date): string {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
        ].join('-');
    };

    today() {
        this.fastDate = 'today';
        let start = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date()),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, start);
    }

    yesterday() {
        this.fastDate = 'yesterday';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-1)));

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-1))),
            end: new FormControl(new Date(today.setDate(today.getDate()-1))),
        });

        this.updateReportData(start, start);
    }

    lastWeek() {
        this.fastDate = 'lastWeek';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-7)));
        let end = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, end);
    }

    lastMonth() {
        this.fastDate = 'lastMonth';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setMonth(today.getMonth()-1)));
        let end = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, end);
    }

    reloadStats(event: MatDatepickerInputEvent<any>) {
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setMonth(today.getMonth()-1)));
        let end = this.convertDateToString(new Date());

        try {
            start = this.dateRange.get('start').value.format('YYYY-MM-DD');
        } catch (e) {
            start = this.convertDateToString(this.dateRange.get('start').value);
        }

        try {
            end = this.dateRange.get('end').value.format('YYYY-MM-DD');
        } catch (e) {
            end = this.convertDateToString(this.dateRange.get('end').value);
        }

        this.updateReportData(start, end);
    }

    showWorkTimeDetailsDialog(userId: string, fromDate: string, toDate: string) {
        this.dialogRef = this._matDialog.open(WorkTimeReportDialogComponent, {
            panelClass: 'work-time-report-dialog',
            data      : {
                action : 'details',
                userId: userId,
                fromDate: fromDate,
                toDate: toDate,
            },
            width: '450px',
        });

        this.dialogRef.afterClosed()
            .subscribe(() => {
                this.dialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }
}
